module.exports = __webpack_public_path__ + "static/two-7e053250aec00f2c2a852bf54ccbea9a.png";